import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import ZDropdown from "../../components/zDropdown/ZDropdown";
import { handlePostRequest } from "../../services/PostTemplate";
import FileStatusSummaryDetail from "./FileStatusSummaryDetail";
import { useHistory } from "react-router-dom";

const FileStatusSummary = () => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [data, setData] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(false);

  let history = useHistory();

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .nullable()
      .max(Yup.ref("toDate"), "From Date cannot be greater than To Date."), // This line ensures fromDate is not greater than toDate
    toDate: Yup.date()
      .nullable()
      .min(Yup.ref("fromDate"), "To Date cannot be lesser than From Date."), // This line ensures toDate is not lesser than fromDate
    companyID: Yup.string().nullable(),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      fromDate: "",
      toDate: "",
      companyID: "",
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        const res = await handlePostRequest(
          data,
          `zbizgateway/fileStatusCheck/fileUploadStatusCheckByCompany`
        );
        setData(res.data);
      } catch (err) {
        console.log(err);
      } finally {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  // useEffect(() => {
  //     if (formik.values.fromDate && formik.values.toDate) {
  //         setBtnDisabled(false)
  //     }
  // }, [formik.values.fromDate, formik.values.toDate]);

  const roleName = localStorage.getItem("roleName");

  const today = new Date();

  return (
    <>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">File Status Summary</h3>
          </div>
        </div>
      </div>
      <div className="card Card__Round">
        <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
          <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZbizInput
                  type="date"
                  label="From Date"
                  keyName="fromDate"
                  {...props}
                />
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZbizInput
                  type="date"
                  label="To Date"
                  keyName="toDate"
                  max={today.toISOString().split("T")[0]}
                  {...props}
                />
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZDropdown
                  {...props}
                  label="Company"
                  required
                  valueOption="companyId"
                  keyName="companyID"
                  placeholder="Select Company"
                  optionLabel="companyName"
                  url="zbizgateway/nonFin/getAllCompanies"
                />
              </div>
            </div>
          </div>

          <div className="GenerateDown__Btn p-mt-4">
            <Button
              loading={loading}
              label="Search"
              className="Btn__Transparent"
              disabled={btnDisabled}
            />
          </div>
        </form>
      </div>

      <FileStatusSummaryDetail data={data} />
    </>
  );
};

export default FileStatusSummary;
